import _ from 'lodash'

/**
 * Returns true/false based on whether or not the input row is open, is root row or is missing parentNode property
 * @param {object} row Table row to check
 * @param {array} openRows Array containing column codes of rows that are open
 * @returns {boolean} True if row should be hidden, false if not
 */
export const hiddenHandler = (row, openRows) => {
    const parentNode = _.get(row, 'parentNode', null)
    const indentationLevel = _.get(row, 'indentationLevel', null)

    if (_.isNull(parentNode)) return false
    if (indentationLevel < 1) return false
    if (_.find(openRows, (x) => x === parentNode)) return false

    return true
}

export const hasDropdownBtn = (section, row) =>
    _.find(_.get(section, 'rows', []), { parentNode: _.get(row, 'columnCode') })

export const rowInOpenRows = (openRows, row) => _.find(openRows, (x) => x === _.get(row, 'columnCode'))

export const childrenAbove = (sectionRows, row) => {
    const rowColumnCode = _.get(row, 'columnCode', null)
    const rowIndex = _.findIndex(sectionRows, { columnCode: rowColumnCode })
    const anyChildIndex = _.findIndex(sectionRows, { parentNode: rowColumnCode })

    // Input row doesn't have any children (for some reason)
    if (anyChildIndex < 0) return false

    // Children rows are above input row
    if (anyChildIndex < rowIndex) return true

    // Children rows are below input row
    return false
}

/**
 * Returns array containing column codes of all rows nested under the input row (specified by parentId).
 * @param {string} parentId Parent row's column code
 * @param {array} sectionRows All rows of table
 * @returns {array} Array of column codes
 */
export const getAllChildrenRowsCodes = (parentId, sectionRows) => {
    const childrenRows = _.filter(sectionRows, { parentNode: parentId })
    let childrenRowsCodes = _.map(childrenRows, (x) => _.get(x, 'columnCode', null))

    _.map(childrenRowsCodes, (code) => {
        if (_.find(sectionRows, { parentNode: code })) {
            const codes = getAllChildrenRowsCodes(code, sectionRows)

            childrenRowsCodes = [...childrenRowsCodes, ...codes]
        }
    })

    return childrenRowsCodes
}

export const isStandardAvailable = (standard) => {
    const maxYear = _.get(standard, 'maxYear', null)
    const minYear = _.get(standard, 'minYear', null)
    const maxAvailableYear = _.get(standard, 'maxAvailableYear', null)
    const minAvailableYear = _.get(standard, 'minAvailableYear', null)

    if (_.isNull(minAvailableYear) || _.isNull(maxAvailableYear)) return -1 // Not available

    const yearsRange = maxYear - minYear
    const availYearsRange = maxAvailableYear - minAvailableYear

    if (availYearsRange >= yearsRange) return 1 // Fully available

    return 0 // Partially available
}
